<template>
    <v-card v-if="displayEl" :class="readOnly && selectedModel ? 'no-model-selected': 'no-model-selected-fix'" >
        <v-card-text style="padding-bottom: 16px;">
            <template v-if="readOnly">
                {{$t('instance.data_model.no_selected_model_composant.read_only_version')}}
            </template>
            <template v-else>
                {{$t('instance.data_model.no_selected_model_composant.edit_create_model_text')}}
            </template>
        </v-card-text>
    </v-card>
</template>

<script>

export default {

    components: {

    },

    props: {
        display: {
            type: Boolean,
            required: true,
        },
        readOnly: {
            type: Boolean,
            required: true,
        },
        selectedModel: {
            type: Boolean,
            required: true,
        },
    },

    data (){
        return {

        };
    },

    computed: {
        displayEl (){
            if(this.readOnly || this.display){
                return true;
            }
            return false;
        }
    },

    mounted (){

    },

    methods: {
    },
};
</script>

<style lang="scss">

    .no-model-selected-fix{
        position: absolute !important;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
        transition: none;
    }
    .no-model-selected{
        margin-bottom: 15px;
    }
</style>



// WEBPACK FOOTER //
// src/components/page/Instance/DataModel/no-selected-model-composant.vue